module.exports = __webpack_public_path__ + "img/Inactive-Managers@2x.2293e33e.png";